// extracted by mini-css-extract-plugin
module.exports = {"gap":"1rem","desktopGap":"2rem","benefitsGrid":"platform-benefits_benefitsGrid__1kqnS","item":"platform-benefits_item__u3cd9"};